// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadCustomerPartNumbers from "@vanmeter/App/Handlers/CPN/loadCustomerPartNumbers";
import { xIsAuthenticated } from "@vanmeter/App/Store/Selectors/GeneralSelectors";

export const XPopulateApiParameter: typeof PopulateApiParameter = props => {
    const pageType = getCurrentPage(props.getState()).type;

    // remove tax from expand on OnePageCheckoutConfirmationPage to prevent re-calculation
    if (pageType === "OnePageCheckoutConfirmationPage") {
        props.apiParameter.expand = (props.apiParameter.expand || []).filter(e => e !== "tax");
    }
};

// XNG-Changes: CPN - Saved Order Details
export const xloadCustomerPartNumbers: typeof PopulateApiParameter = props => {
    const isAuth = xIsAuthenticated(props.getState());

    if (!props.apiResult?.cart?.cartLines || props.apiResult.cart.cartLines.length === 0 || !isAuth) {
        return;
    }
    const productIds = props.apiResult.cart.cartLines.map(cartLine => cartLine.productId);

    props.dispatch(
        loadCustomerPartNumbers({
            productIds,
        }),
    );
};

addToChainAfter(chain, PopulateApiParameter, XPopulateApiParameter);
addToEndOfChain(chain, xloadCustomerPartNumbers);
